import { Loader2 } from 'lucide-react';

import { useWorkspace } from '@/contexts/WorkspaceContext';

export function WorkspaceSwitchOverlay() {
    const { switching } = useWorkspace();

    if (!switching) return null;

    return (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-3">
                <Loader2 className="size-8 animate-spin text-muted-foreground" />
                <span className="text-sm text-muted-foreground">Switching workspace...</span>
            </div>
        </div>
    );
}
